const TELEGRAM_USERNAME = 'daniil_tlg';
const DEFAULT_EXAMPLE_LINK = 'https://legenda-dom.ru/';

const TELEGRAM_DEFAULT_MESSAGE = `Здравствуйте! Хочу получить план запуска проекта.

Коротко опишу задачу: ___`;

const buildCaseTelegramMessage = (exampleLink) => `Здравствуйте! Хочу похожий проект:
${exampleLink}

Коротко опишу задачу: ___`;

export const TELEGRAM_CTA_URL = `https://t.me/${TELEGRAM_USERNAME}?text=${encodeURIComponent(TELEGRAM_DEFAULT_MESSAGE)}`;

export const getTelegramCtaUrl = (portfolioLink = '') => {
  const trimmedLink = portfolioLink.trim();
  const message = buildCaseTelegramMessage(trimmedLink || DEFAULT_EXAMPLE_LINK);

  return `https://t.me/${TELEGRAM_USERNAME}?text=${encodeURIComponent(message)}`;
};
